import { type PropsWithChildren } from 'react';
import { type Link as SanityLinkFields } from '@root/sanity/sanity.types';
import TrackedLink from './TrackedLink';

type CommonLinkFields = Omit<SanityLinkFields, '_type' | 'title'>;

type LinkProps = PropsWithChildren<CommonLinkFields & { className?: string }>;

const SanityLink = ({ href, children, className, elementLabel, trackerClass, newTab = false, includeQueryString = false }: LinkProps) => {
  if (trackerClass) {
    className = className ? `${className} ${trackerClass}` : trackerClass;
  }

  const newTabAttrs = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};

  return (
    <TrackedLink href={href} className={className} elementLabel={elementLabel} includeQueryString={includeQueryString} {...newTabAttrs}>
      {children}
    </TrackedLink>
  );
};

export default SanityLink;
